import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const NewJersey = () => {
  return (
    <StatePropertyTaxPage
      stateName="New Jersey"
      processDescription="Property owners may appeal their assessment by filing with the county board of taxation within 45 days of notification, or by April 1, May 1, or June 1 depending on the municipality's tax year. Appeals should include evidence supporting the property owner's valuation."
      noticeOfValueMailed="February"
      noticeOfValueMailedDateExplanation="Assessment notices are typically mailed in February to allow property owners time to review and potentially appeal their assessments."
      valuationAsOfDate="October 1"
      valuationAsOfDateExplanation="New Jersey assesses property as of October 1 of the prior year. This fall assessment date captures market conditions near the end of the traditional real estate selling season."
      deadlineExplanation="Appeal deadlines vary by municipality but are typically April 1, May 1, or June 1, or within 45 days of notification. Property owners should check with their local tax assessor for specific deadlines."
    />
  );
};

export default NewJersey;